export default __webpack_public_path__ + "./images/mw.7ae86877.png";